import { jsx, jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import MuiRadio from "@mui/material/Radio";
import useRadioGroup from "@mui/material/RadioGroup/useRadioGroup";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { Card } from "../Card/index.js";
import { stackedStyles } from "../StackableCard/index.js";
import "@mui/material/Card";
const transientProps = {
  shouldForwardProp: (propName) => !propName.startsWith("$")
};
const StyledCard = styled(Card, transientProps)(({
  color,
  $isSelected,
  theme,
  disabled,
  $unstacked
}) => {
  var _a;
  const cardRootStyles = {
    ...$unstacked ? {} : stackedStyles,
    "&:not(:last-child)": {
      borderBottom: `1px solid transparent ${theme.palette.secondary.border}`
    },
    ".MuiCardContent-root": {
      paddingLeft: "7px"
    }
  };
  const sharedStyles = {
    borderColor: `${theme.palette.secondary.border}`,
    backgroundColor: (_a = theme.palette[color]) == null ? void 0 : _a.background,
    zIndex: "1"
  };
  if (disabled) {
    return {
      cursor: "not-allowed",
      color: `${theme.palette.text.disabled}`,
      ...cardRootStyles
    };
  }
  if ($isSelected) {
    return {
      "&:not([disabled])": sharedStyles,
      ...cardRootStyles
    };
  }
  return {
    "&:hover:not([disabled])": sharedStyles,
    ...cardRootStyles
  };
});
function SelectableCard({
  children,
  className,
  label,
  sx,
  value,
  disabled,
  variant = "default",
  unstacked = false
}) {
  const rGroup = useRadioGroup();
  const isSelected = (rGroup == null ? void 0 : rGroup.value) === value;
  const selectedProps = isSelected ? {
    color: "secondary",
    variant: "contained"
  } : {};
  let cardContent;
  switch (variant) {
    case "full":
      cardContent = /* @__PURE__ */ jsxs(CardContent, { sx: {
        display: "flex",
        flexDirection: "column"
      }, children: [
        /* @__PURE__ */ jsxs(Box, { display: "flex", alignItems: "center", children: [
          /* @__PURE__ */ jsx(MuiRadio, { id: `radio-${value}`, value, disabled }),
          /* @__PURE__ */ jsx(Grid, { container: true, direction: "column", children: typeof label === "string" ? /* @__PURE__ */ jsx(Typography, { variant: "h6", children: label }) : label })
        ] }),
        /* @__PURE__ */ jsx(Box, { sx: {
          px: "10px"
        }, children })
      ] });
      break;
    default:
      cardContent = /* @__PURE__ */ jsxs(CardContent, { sx: {
        display: "flex",
        alignItems: label && children ? "start" : "center"
      }, children: [
        /* @__PURE__ */ jsx(MuiRadio, { id: `radio-${value}`, value, disabled }),
        /* @__PURE__ */ jsxs(Grid, { container: true, direction: "column", sx: {
          mt: label && children ? 1 : 0
        }, children: [
          typeof label === "string" ? /* @__PURE__ */ jsx(Typography, { variant: "h6", children: label }) : label,
          children
        ] })
      ] });
  }
  return /* @__PURE__ */ jsx(StyledCard, { className, ...selectedProps, disabled, $isSelected: isSelected, $unstacked: unstacked, sx, children: /* @__PURE__ */ jsx(CardActionArea, { component: "label", disabled, role: void 0, tabIndex: -1, children: cardContent }) });
}
export {
  SelectableCard,
  transientProps
};
//# sourceMappingURL=index.js.map
